// routes/_authenticated/heatmap.tsx — entry point for the
// `/heatmap` page. The page itself lives in
// `@/features/heatmap/index.tsx`; this file is just the router glue.
import { createFileRoute } from "@tanstack/react-router";

import { HeatmapPage } from "@/features/heatmap";

export const Route = createFileRoute("/_authenticated/heatmap")({
  component: HeatmapPage,
});
